// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SessionEngineRecurrentResponse

import { OfferEngineType } from './enums.gen';
import { hydrateSessionEngineCapacityDuration, type SessionEngineCapacityDuration, type SessionEngineCapacityDurationApiResponse } from './sessionEngineCapacityDuration.gen';

export type SessionEngineRecurrentApiResponse = {
	type: OfferEngineType.Recurrent;
	cleaningDuration: number;
	debriefingDuration: number;
	onboardingDuration: number;
	preparationDuration: number;
	interval: number;
	capacityDurations: SessionEngineCapacityDurationApiResponse[];
};

export type SessionEngineRecurrent = {
	type: OfferEngineType.Recurrent;
	cleaningDuration: number;
	debriefingDuration: number;
	onboardingDuration: number;
	preparationDuration: number;
	interval: number;
	capacityDurations: SessionEngineCapacityDuration[];
};

export function hydrateSessionEngineRecurrent(data: SessionEngineRecurrentApiResponse): SessionEngineRecurrent {
	return {
		...data,
		capacityDurations: data.capacityDurations.map(hydrateSessionEngineCapacityDuration),
	};
}